export const banner_message = 'banner_message';
export const alert_message = 'alert_message';
